import { sprache } from './sprache';

/**
 * Vermerk für Berichte aus dem Testmodus (seit 12.10.2026, Server: testmodus.ts,
 * Feld `testlauf` in der Nutzlast). Ein Bericht aus Runs auf dem günstigen
 * Testmodell sieht sonst aus wie ein echter und könnte so beim Kunden landen.
 * Ohne Feld (jeder echte und jeder ältere Bericht): null, nichts ändert sich.
 */
export function testlaufSatz(data: any): string | null {
  const t = data?.testlauf;
  if (!t) return null;
  const modelle = Array.isArray(t.modelle) && t.modelle.length ? ` (${t.modelle.join(', ')})` : '';
  const einzeln = (Number(t.runs) || 0) + (Number(t.design_checks) || 0) === 1;
  if (sprache() === 'en') {
    const teile = [
      t.runs ? `${t.runs} ${t.runs === 1 ? 'test round' : 'test rounds'}` : '',
      t.design_checks ? `${t.design_checks} ${t.design_checks === 1 ? 'design check' : 'design checks'}` : '',
    ].filter(Boolean).join(' and ');
    return `Test run: ${teile || 'Parts of this report'} ran on a low-cost test model${modelle}. `
      + 'The verdicts are not reliable. Do not pass this report on.';
  }
  const teile = [
    t.runs ? `${t.runs} ${t.runs === 1 ? 'Testrunde' : 'Testrunden'}` : '',
    t.design_checks ? `${t.design_checks} ${t.design_checks === 1 ? 'Design-Check' : 'Design-Checks'}` : '',
  ].filter(Boolean).join(' und ');
  return `Testlauf: ${teile || 'Teile dieses Berichts'} ${einzeln ? 'lief' : 'liefen'} auf einem günstigen Testmodell${modelle}. `
    + 'Die Urteile sind nicht belastbar. Diesen Bericht nicht weitergeben.';
}
